var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('QrcodeVue',{style:(`width: ${_vm.size}px`),attrs:{"value":_vm.fullUrl,"size":_vm.size,"render-as":"svg","level":"L","background":_vm.bgColor,"foreground":_vm.qrColor}})
}
var staticRenderFns = []

export { render, staticRenderFns }